<template>
  <div class="renew-box">
    <app-header title="服务续费" @goback="goBack">
      <div slot="tips" @click="cancelSelect" v-show="isShowCheck">
        <div class="header-right">取消</div>
      </div>
    </app-header>
    <div class="module-box" @click="openModule">
      <span>{{currentModule.text}}</span><i class="iconfont iconxiala"></i>
    </div>
    <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul class="renew-list" ref="renewLlist">
        <li v-for="(item, index) in renewList" :key="index" @click="check(item, index)">
          <checkbox disabled v-model="checkedIds" class="list-checkbox" :value="item.id" v-if="isShowCheck" ref="checkbox"></checkbox>
          <div class="renew-right">
            <div class="renew-top">
              <div class="renew-top-title">{{ item.productType === 1 ? item.deptName : item.deviceName }}</div>
              <div v-show="item.status !== 3" class="renew-top-type" @click="showRenewType(item, index)">{{ item.autoRenew === false ? '手动续费' : '自动续费' }}<i class="iconfont iconedit"></i></div>
            </div>
            <div class="renew-bottom">
              <div class="renew-bottom-time">{{ item.productType === 1 ? '门店剩余时间：' : '设备剩余时间' }}<span>{{`${caclLastTime(item.expireTime)}天`}}</span></div>
              <div class="renew-bottom-btn" v-show="item.autoRenew === false && item.status !== 3" @click="showRenewDialog(item)">续费</div>
            </div>
          </div>
        </li>
      </ul>
    </pull-to>
    <div class="renew-submit-box" v-if="isShowCheck">
      <!-- <cube-input class="renew-input" placeholder="请输入续费时长" v-model="monthData"></cube-input> -->
      <number-input :controls="false" :precision="0" :max="maxMonth" :min="1" class="renew-input" v-model="monthData" placeholder="请输入续费时长(月)"></number-input>
      <div class="renew-confirm" @click="confirmRenew">确定续费</div>
      <div class="renew-month">月</div>
      <div class="renew-price">{{`总计年收费：${totalPrice}`}}</div>
    </div>
    <Button v-else class="submit-btn" @click="someRenew">批量续费</Button>
    <renew-modal :order="currentOrder" @confirm="confirmOneRenew"></renew-modal>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import apis from 'api/index';
import { Checkbox } from 'vue-checkbox-radio';
import PullTo from 'vue-pull-to';
import renewModal from './components/renew-modal';
import moment from 'moment';
import VueNumericInput from 'vue-numeric-input';
import calcPrice from 'common/js/price-calculator';

export default {
  mixins: [commonMixin],
  components: {
    Checkbox,
    PullTo,
    renewModal,
    numberInput: VueNumericInput
  },
  data() {
    return {
      tabList: [
        { label: '批次续费', value: 0 },
        { label: '门店/设备续费', value: 1 }
      ],
      renewTypeList: [
        { text: '手动续费', value: 0 },
        { text: '自动续费', value: 1 }
      ],
      modulesList: [], // 模块列表
      currentModule: {}, // 当前模块列表
      pageNumber: 1,
      pageSize: 10,
      renewList: [],
      renewTotal: 0,
      checkedIds: [],
      isShowCheck: false, // 是否显示checkbox
      monthData: null,
      currentOrder: {}, // 当前续费的order信息
    }
  },
  created() {
    this.fetchModuleList().then(res => {
      this.modulesList = this._normalizeModule(res);
      this.modulesList.unshift({ id: null, text: '全部模块', });
      this.currentModule = this.modulesList[0];
      this.fetchRenewList();
    });
  },
  computed: {
    // 用来控制是否启用下拉刷新
    isLoadAll() {
      return Boolean(this.renewTotal > this.pageNumber * this.pageSize);
    },
    selectList() {
      return this.renewList.filter(item => {
        for(let i = 0; i < this.checkedIds.length; i++) {
          if(item.id === this.checkedIds[i]) {
            return item
          }
        }
      });
    },
    totalPrice() {
      let totalPrice = this.selectList.reduce((prev, curr) => {return prev + calcPrice(curr, this.monthData, 2)}, 0);
      return totalPrice.toFixed(2);
    },
    maxMonth() { // 计算最大能填写的月份
      let maxMonthArr = this.selectList.map(item => (60 - item.usedMonthNum - item.rentFreeDuration));
      return Math.min.apply(null, maxMonthArr);
    }
  },
  watch: {
    isShowCheck(nVal) {
      nVal ? this.$refs.renewLlist.style.marginBottom = '100px' : this.$refs.renewLlist.style.marginBottom = '50px';
    },
    checkedIds() { // 解决最大值变化，值没变的bug
      if(this.monthData > this.maxMonth) {
        this.monthData = this.maxMonth;
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 点击行选中
    check(item, index) {
      if(!this.isShowCheck) return false;
      this.$refs.checkbox[index].toggle(item.depId);
    },
    // 打开选择pop
    openModule() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '选择模块',
          data: [this.modulesList],
          onSelect: this.changeModule,
        })
      }
      this.picker.show();
    },
    // 切换模块
    changeModule(value) {
      this.currentModule = this.modulesList.filter(item => item.value === value[0])[0];
      this.pageNumber = 1;
      this.fetchRenewList('change');
    },
    cancelSelect() {
      this.isShowCheck = false;
      this.checkedIds = [];
      this.monthData = null;
    },
    // 修改续费方式
    showRenewType(item, index) {
      let selectIndex = this.renewTypeList.findIndex(type => Boolean(type.value) === Boolean(item.autoRenew));
      this.typePicker = this.$createPicker({
        title: '选择续费方式',
        data: [this.renewTypeList],
        selectedIndex: [selectIndex],
        onSelect: (type) => {
          let autoRenew = type[0] === 1 ? true : false
          let params = {
            ids: [item.id],
            status: item.status,
            autoRenew
          }
          apis.updateRenewType(JSON.stringify(params)).then(res => {
            // 成功了我就先不去刷新数据了，直接修改数据里的autoRenew
            this.$set(this.renewList[index], 'autoRenew', autoRenew);
            this.showToast('修改成功', 'success');
          });
        },
      });
      this.typePicker.show();
    },
    // 单个续费
    showRenewDialog(order) {
      this.currentOrder = order;
      this.$modal.show('renew-modal');
    },
    // 单个续费
    confirmOneRenew(orderId, monthDuration, price) {
      let params = {
        ids: [orderId],
        duration: monthDuration,
        totalPrice: price
      };
      this.renew(params);
    },
    // 批量续费
    confirmRenew() {
      if(!this.monthData) {
        this.showToast('请输入续费时长');
        return false;
      }
      if(this.checkedIds.length === 0) {
        this.showToast('请选择订单');
        return false;
      }
      let params = {
        ids: this.checkedIds,
        duration: this.monthData,
        totalPrice: this.totalPrice
      };
      this.renew(params);
    },
    someRenew() {
      this.isShowCheck = true;
    },
    // 续费
    async renew(params) {
      try {
        const res = await apis.usedRenew(JSON.stringify(params));
        this.pageNumber = 1;
        this.fetchRenewList('change');
        this.showToast('续费成功', 'correct');
        this.checkedIds = [];
        this.monthData = null;
      } catch(err) {
        this.showToast('续费失败');
        console.error(err);
      }
    },
    loadmore(loaded) {
      if(this.renewTotal <= this.pageNumber * this.pageSize) {
        return false;
      }
      this.pageNumber +=1;
      this.fetchRenewList().then(res => {
        loaded('done');
      });
    },
    async fetchRenewList(type = 'normal') { // type, change 改变module， normal 正常分页
      let params = {};
      // params.groupId = this.userAllInfo.enterprise.id;
      params.no = this.pageNumber;
      params.limit = this.pageSize;
      params.moduleId = this.currentModule.id;
      const res = await apis.getOrderOpens(params);
      if(res) {
        if(type === 'change') {
          this.renewList = res.records;
        } else {
          this.renewList = this.renewList.concat(res.records);
        }
        this.renewTotal = res.total;
      }
    },
    // 计算剩余时间
    caclLastTime(expireTime) {
      let duration = moment(expireTime).valueOf() - moment().valueOf();
      if(duration < 0) {
        return 0
      } else {
        return parseInt(moment.duration(duration).asDays());
      }
    }
  },
}
</script>

<style src="./renew.scss" lang="scss" scoped></style>
<style lang="scss">
.renew-box {
  .numeric-input {
    width: 100%;
    height: 45px;
    padding-right: 40px;
    border-color: #E6E6E6;
    padding-right: 50px;
    font-size: 14px;
    outline: none;
    -webkit-appearance: none;
  }
}
</style>

